export default __webpack_public_path__ + "media/manually.c6c4b764.svg";